"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const loftTypes = [{
  title: "Dormer Conversion",
  description: "Extends vertically from the slope of your existing roof, creating significant additional floor space and headroom. The premier choice for maximizing usable area with structural elegance."
}, {
  title: "Mansard Conversion",
  description: "Situated at the rear of your property, a mansard conversion alters the roof structure to create a flat roof with a steeply sloping back wall. This option offers maximum space and a distinct architectural presence."
}, {
  title: "Velux Conversion",
  description: "Also known as a rooflight conversion, this method retains your existing roofline while installing large, strategically placed windows. A refined approach to flood your new attic space with natural light."
}];
export default function TheLoftConversionSpecialist() {
  return <section id="the-loft-conversion-specialist" className="dark bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="relative w-full h-[60vh] min-h-[500px] lg:h-[850px] border border-border/50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586109/img/luxury_dormer_loft_conversion_nw_london.png" alt="Luxury Dormer Loft Conversion by SolidTrust Builders" className="absolute inset-0 w-full h-full object-cover grayscale-[0.15] contrast-110" />
            {}
            <div className="absolute top-0 left-0 w-full h-1 bg-foreground/20"></div>
            <div className="absolute top-0 left-0 w-1 h-full bg-foreground/20"></div>
          </div>

          {}
          <div className="flex flex-col space-y-10">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter uppercase text-foreground leading-tight">
                The Loft Conversion Specialist
              </h2>
              <div className="w-20 h-1 bg-foreground"></div>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-serif">
                At SolidTrust Builders, we transform underutilized spaces into
                breathtaking living areas. Whether you are considering a
                comprehensive <strong className="text-foreground font-semibold">attic conversion</strong> to
                add a new master suite or a seamless <strong className="text-foreground font-semibold">loft extension</strong> to
                accommodate a growing family, our expert team delivers
                unparalleled craftsmanship across North West London.
              </p>
            </div>

            <div className="w-full">
              <Accordion type="single" collapsible className="w-full border-t border-border">
                {loftTypes.map((type, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border">
                    <AccordionTrigger className="text-lg md:text-xl font-semibold uppercase tracking-wide hover:no-underline hover:text-muted-foreground transition-colors py-6">
                      {type.title}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6 font-serif">
                      {type.description}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>

            <div className="pt-4">
              <Button size="lg" variant="outline" className="uppercase tracking-widest rounded-none border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors duration-300 h-14 px-8 text-sm font-bold" asChild>
                <Link to="/OurCraftPage">Explore Our Craft</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}